export default {"src":"/_next/static/media/no_image.30682e1a.svg","height":433,"width":668,"blurWidth":0,"blurHeight":0};